import type { StateCreator } from 'zustand';

import type { UUID } from '@cobliteam/common-types';

export interface MediaSliceState {
  mediaViewId?: UUID;
  setMediaViewId: (id?: UUID) => void;
  clearMediaViewId: () => void;
}

type StateCreatorMedia = StateCreator<
  MediaSliceState,
  [['zustand/devtools', never]],
  [],
  MediaSliceState
>;

const mediaSlice: StateCreatorMedia = (set) => ({
  mediaViewId: undefined,
  setMediaViewId: (id?: UUID) =>
    set(() => ({
      mediaViewId: id,
    })),
  clearMediaViewId: () => set({ mediaViewId: undefined }),
});

export default mediaSlice;
